module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/form/form1/form1.component.scss
// module id = ./src/app/features/form/form1/form1.component.scss
// module chunks = main